import { useState } from "react";

import PatientAppointments from "./PatientAppointments";
import PatientSettings from "./PatientSettings";

const PatientDashboard = ({ patient, patientLogout, orgId, orgContactNum }) => {
    const [settingsOpen, setSettingsOpen] = useState(true);
    const [logoutHover, setLogoutHover] = useState(false);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
            }}
        >
            {/* ── Orange header ── */}
            <div
                style={{
                    background: "#EA8331",
                    borderRadius: 14,
                    padding: "18px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                }}
            >
                <div>
                    <div
                        style={{
                            fontSize: 18,
                            fontWeight: 500,
                            color: "#FFFFFF",
                            fontFamily: "Roboto, sans-serif",
                        }}
                    >
                        Welcome{patient?.firstName ? `, ${patient.firstName}` : ""}
                    </div>
                    <div
                        style={{
                            fontSize: 13,
                            color: "rgba(255,255,255,0.72)",
                            marginTop: 3,
                            fontFamily: "Roboto, sans-serif",
                        }}
                    >
                        Manage your appointments and preferences
                    </div>
                </div>

                <button
                    onClick={patientLogout}
                    onMouseEnter={() => setLogoutHover(true)}
                    onMouseLeave={() => setLogoutHover(false)}
                    style={{
                        padding: "8px 18px",
                        borderRadius: 9,
                        border: "1.5px solid rgba(255,255,255,0.55)",
                        background: logoutHover
                            ? "rgba(255,255,255,0.18)"
                            : "rgba(255,255,255,0.1)",
                        color: "#FFFFFF",
                        fontSize: 13,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontFamily: "Roboto, sans-serif",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        transition: "background 0.15s",
                    }}
                >
                    Log out
                </button>
            </div>

            {/* ── Settings card ── */}
            <div
                style={{
                    background: "#FFFFFF",
                    border: "0.5px solid rgba(15,23,42,0.08)",
                    borderRadius: 14,
                    overflow: "hidden",
                }}
            >
                {/* Collapsible header */}
                <button
                    onClick={() => setSettingsOpen((v) => !v)}
                    style={{
                        width: "100%",
                        padding: "13px 16px",
                        background: "#FBF4EE",
                        border: "none",
                        borderBottom: settingsOpen
                            ? "0.5px solid rgba(234,131,49,0.15)"
                            : "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        fontFamily: "Roboto, sans-serif",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        {/* Settings gear icon */}
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#EA8331"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <circle cx="12" cy="12" r="3" />
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                        </svg>
                        <span
                            style={{
                                fontSize: 13,
                                fontWeight: 500,
                                color: "#EA8331",
                            }}
                        >
                            Settings
                        </span>
                    </div>

                    <span
                        style={{
                            fontSize: 13,
                            color: "#EA8331",
                            display: "inline-block",
                            transform: settingsOpen ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s",
                        }}
                    >
                        ▾
                    </span>
                </button>

                {settingsOpen && (
                    <div style={{ padding: 16 }}>
                        <PatientSettings patient={patient} />
                    </div>
                )}
            </div>

            {/* ── Appointments card ── */}
            <div
                style={{
                    background: "#FFFFFF",
                    border: "0.5px solid rgba(15,23,42,0.08)",
                    borderRadius: 14,
                    overflow: "hidden",
                }}
            >
                {/* Static header */}
                <div
                    style={{
                        padding: "13px 16px",
                        background: "#F0F7FF",
                        borderBottom: "0.5px solid rgba(46,144,250,0.15)",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                    }}
                >
                    {/* Calendar icon */}
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#2E90FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                    >
                        <rect x="3" y="4" width="18" height="18" rx="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <span
                        style={{
                            fontSize: 13,
                            fontWeight: 500,
                            color: "#2E90FA",
                            fontFamily: "Roboto, sans-serif",
                        }}
                    >
                        Appointments
                    </span>
                </div>

                <div style={{ padding: 16 }}>
                    <PatientAppointments patient={patient} orgId={orgId} orgContactNum={orgContactNum} />
                </div>
            </div>
        </div>
    );
};

export default PatientDashboard;